import { FormikProps } from 'formik'
import * as React from 'react'
import TextField from '../ui/TextField'

interface IServiceProgramFormProps {
  formikProps: FormikProps<any>
  labelTitle: string
  children: React.ReactNode
}

const SettingForm = (props: IServiceProgramFormProps) => (
  <form onSubmit={props.formikProps.handleSubmit}>
    <div className='mb1'>
      <TextField
        title={props.labelTitle}
        name={'label'}
        optional={false}
        error={props.formikProps.errors.label}
        classNameContainer={'mr1'}
        touched={props.formikProps.touched.label}
        onChange={props.formikProps.handleChange}
        value={props.formikProps.values.label}
        className='mt1 p1 border-light-grey4 rounded h5'
        placeholder={props.labelTitle}
      />
    </div>
    {props.children}
  </form>
)

export default SettingForm



// WEBPACK FOOTER //
// ./src/components/global-settings/SettingForm.tsx